import { makeStyles } from '@material-ui/core'
import { ClearRounded, SearchRounded } from '@mui/icons-material'
import { useState } from 'react'
import { COLORS } from 'src/utils/Themes/colors'

export const CustomSearch = ({ value, onSearch, placeHolder }) => {
  const classes = useStyles()
  const [searchText, setSearchText] = useState(value ?? '')

  const handleSearchTextChange = (event) => {
    setSearchText(event.target.value.replace(/[^a-zA-Z\d]/gi, ''))
  }

  const clearSearchText = () => {
    setSearchText('')
    onSearch('')
  }

  const handleSearch = () => {
    onSearch(searchText)
  }

  const isClearIconVisible = () => {
    return !!searchText?.length
  }

  return (
    <>
      <div className={classes.container}>
        <input
          id='searchControl'
          className={classes.inputField}
          value={searchText}
          onChange={handleSearchTextChange}
          placeholder={placeHolder ?? 'Search'}
          onKeyDown={(event) => {
            if (event?.key === 'Enter') {
              handleSearch()
            }
          }}
        />
        {isClearIconVisible() && (
          <>
            <ClearRounded
              id='clearIcon'
              className={classes.actionIcon}
              onClick={clearSearchText}
            />
            <SearchRounded
              id='searchIcon'
              className={classes.actionIcon}
              onClick={handleSearch}
            />
          </>
        )}
      </div>
    </>
  )
}

export const useStyles = makeStyles({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: `1px solid ${COLORS.DARK_PINK}`,
    borderRadius: '50px',
    height: '25px',
    width: '250px',
    paddingRight: '3px',
    '&:focus-within': {
      background: COLORS.WHITE,
      color: COLORS.DARK_PINK,
    },
  },
  inputField: {
    border: 'unset',
    height: '25px',
    lineHeight: '0.5',
    padding: '0',
    borderRadius: '50px',
    paddingLeft: '5px',
    fontSize: '12px',
    width: '100%',
    background: 'transparent',
    '&:focus': {
      background: COLORS.WHITE,
      color: COLORS.DARK_PINK,
    },
  },
  actionIcon: {
    height: '22px',
    width: '22px',
    cursor: 'pointer',
    color: COLORS.DARK_PINK,
    opacity: '0.5',
    '&:hover': {
      opacity: 'unset',
    },
    '&:focus': {
      background: COLORS.WHITE,
      color: COLORS.DARK_PINK,
    },
  },
})
